"use client"

import React from "react"
import LoginHeader from "./components/LoginHeader.js"
import SideNavigation from "./components/SideNavigation.js"
import { useState, useEffect } from "react"
import "react-multi-carousel/lib/styles.css"
import "react-calendar/dist/Calendar.css"
import { appInsights } from "./AppInsights"
import { useNavigate } from "react-router-dom"
import Highcharts from "highcharts"
import HighchartsReact from "highcharts-react-official"
import HighchartsExporting from "highcharts/modules/exporting"
import HighchartsOfflineExporting from "highcharts/modules/offline-exporting"
import HighchartsFullscreen from "highcharts/modules/full-screen"
import CircularProgress from "@mui/material/CircularProgress"
import highchartsMore from "highcharts/highcharts-more"
import HighchartsMap from "highcharts/modules/map" // Import the map module
import proj4 from "proj4"
import SolidGauge from "highcharts/modules/solid-gauge"
import AADHeader from "./components/AADHeader.js"
import { MdRefresh } from "react-icons/md"
import { Switch } from "antd"
import "./components/Travel_Logistic/BTCEC.css"
import { Typography, Backdrop, Breadcrumbs, Link, Button } from "@mui/material"
import NavigateNextIcon from "@mui/icons-material/NavigateNext"

const dashboardStyles = {
  cardContainer: {
    gap: "0px",
    margin: "0px 0",
  },
  card: {
    marginBottom: "20px",
    padding: "15px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    borderRadius: "8px",
    backgroundColor: "#fff",
  },
}

// No Data Component
const NoDataComponent = ({ title, onConfigureClick }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "280px",
      backgroundColor: "#f8f9fa",
      borderRadius: "8px",
      border: "1px dashed #dee2e6",
      textAlign: "center",
      padding: "20px",
    }}
  >
    <div style={{ marginBottom: "20px" }}>
      <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9 17H7V10H9M13 17H11V7H13M17 17H15V13H17M19.5 19.1H4.5V5H19.5M19.5 3H4.5C3.4 3 2.5 3.9 2.5 5V19.1C2.5 20.2 3.4 21.1 4.5 21.1H19.5C20.6 21.1 21.5 20.2 21.5 19.1V5C21.5 3.9 20.6 3 19.5 3Z"
          fill="#6c757d"
        />
      </svg>
    </div>
    <h6 style={{ color: "#6c757d", marginBottom: "10px", fontFamily: "Poppins" }}>No Data Available</h6>
    <p style={{ color: "#6c757d", marginBottom: "20px", fontSize: "14px" }}>Please configure the data for visual</p>
    <Button
      variant="contained"
      onClick={onConfigureClick}
      style={{
        backgroundColor: "#407775",
        color: "white",
        textTransform: "none",
        fontFamily: "Poppins",
        borderRadius: "6px",
        padding: "8px 20px",
      }}
    >
      Configure Data
    </Button>
  </div>
)

// Initialize the exporting module
HighchartsExporting(Highcharts)
HighchartsOfflineExporting(Highcharts)
HighchartsFullscreen(Highcharts)
HighchartsMap(Highcharts)
highchartsMore(Highcharts)
SolidGauge(Highcharts)
// Global Highcharts options for consistent styling
Highcharts.setOptions({
  colors: [
    "#407775",
    "#fab430",
    "#c8e1e0",
    "#b8d9d8",
    "#b8d9d8",
    "#b8d9d8",
    "#b8d9d8",
    "#fcd283",
    "#fde4b4",
    "#fbc051",
    "#e09405",
    "#fef6e6",
  ],
  chart: {
    style: {
      fontFamily: "Poppins, sans-serif",
    },
    backgroundColor: "#ffffff",
    height: 300, // Set a compact height for all charts
  },
  title: {
    style: {
      fontSize: "16px",
      fontWeight: "400",
      color: "#494949",
    },
    align: "left",
  },
  legend: {
    enabled: true,
    itemStyle: {
      color: "#494949",
      fontWeight: "400",
      fontSize: "12px",
    },
    itemMarginTop: 6,
    itemMarginBottom: 6,
    symbolRadius: 6,
  },
  tooltip: {
    style: {
      fontSize: "12px",
    },
  },
  xAxis: {
    labels: {
      style: {
        fontSize: "12px",
        color: "#707070",
      },
    },
  },
  yAxis: {
    labels: {
      style: {
        fontSize: "12px",
        color: "#707070",
      },
    },
    title: {
      style: {
        fontSize: "14px",
        color: "#C2BEBE",
      },
    },
  },
  credits: {
    enabled: false, // Disable Highcharts credit label
  },
  exporting: {
    enabled: false, // Hide export/download button
  },
})

// CSS for compact chart containers
const chartContainerStyle = `
  .charts {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding: 15px;
    margin-bottom: 20px;
    height: 350px; /* Fixed height for compact charts */
    overflow: hidden;
  }
  @media (max-width: 768px) {
    .charts {
      height: 300px; /* Smaller height for mobile */
    }
  }
`

// Inject CSS into the document
const styleSheet = document.createElement("style")
styleSheet.type = "text/css"
styleSheet.innerText = chartContainerStyle
document.head.appendChild(styleSheet)

export default function Home() {
  const username = localStorage.getItem("userName")
  const companyid = localStorage.getItem("companyid")
  const navigate = useNavigate()
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768)
  const [isLoading, setIsLoading] = useState(false)
  const [loading, setLoading] = React.useState(false)
  const [emissionbased, setEmissionBased] = React.useState(false)
  const [news, setNews] = useState(false)
  const [responseConfig, setResponseConfig] = useState({})
  const [legal, setLegal] = useState([])
  const [business, setBusiness] = useState([])
  const [site, setSite] = useState([])
  const [year, setYear] = useState([])
  const [allSupplier, setAllSupplier] = useState("")
  const [supplier, setSupplier] = useState([])
  const [country, setCountry] = useState([])
  const [employee, setEmployee] = useState("")
  const [scope, setScope] = useState("")
  const [yearr, setYearR] = useState("")
  const [countries, setCountries] = useState()
  const [businessunit, setBusinessUnit] = useState()
  const [activesite, setActiveSite] = useState()
  const [activeetities, setActiveEntities] = useState()
  const [activeyears, setActiveYears] = useState()
  const [checked, setChecked] = useState(true)
  const [viewMode, setViewMode] = useState("locationBased")
  const [optionsChart4, setOptionsChart4] = useState({})
  const [optionsChart6, setOptionsChart6] = useState({})
  const [isUpstream, setIsUpstream] = useState(true)
  const [businessTravelDashboard, setBusinessTravelDashboard] = useState("")

  const handleToggle = () => {
    setIsUpstream((prev) => !prev)
  }

  // Function to handle configuration redirect
  const handleConfigureClick = () => {
    navigate("/configuration") // Update this path to your actual configuration route
  }

  // Function to handle eye icon click
  const handleEyeIconClickBusiness = () => {
    window.open("/Business-travel-dashboard", "_blank") // Dummy URL - replace with actual URL
  }
   // Function to handle eye icon click
  const handleEyeIconClickEmployee = () => {
    window.open("/Employee-commute-dashboard", "_blank") // Dummy URL - replace with actual URL
  }
  // Function to handle eye icon click
  const handleEyeIconClickTransportation = () => {
    window.open("/transportation-Distribution-Dashboard", "_blank") // Dummy URL - replace with actual URL
  }
  // Function to check if data exists and has values
  const hasValidData = (data) => {
    if (!data || typeof data !== "object") return false
    if (Array.isArray(data)) return data.length > 0
    return Object.keys(data).length > 0 && Object.values(data).some((value) => value > 0)
  }

  if (typeof window !== "undefined") {
    window.proj4 = window.proj4 || proj4
  }

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev)
  }

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false) // Close sidebar on mobile
      } else {
        setIsSidebarOpen(true) // Open sidebar on larger screens
      }
    }

    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  var myHeaders = new Headers()
  myHeaders.append("username", username)
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  }

  async function fetchFilters() {
    try {
      const country = JSON.parse(localStorage.getItem("travelLogisticCountry")) || []
      const year = JSON.parse(localStorage.getItem("travelLogisticYear")) || []
      const legal = JSON.parse(localStorage.getItem("travelLogisticLegal")) || []
      const business = JSON.parse(localStorage.getItem("travelLogisticBusiness")) || []
      const site = JSON.parse(localStorage.getItem("travelLogisticSite")) || []
      const supplier = JSON.parse(localStorage.getItem("travelLogisticSupplier")) || []

      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}scope2-filters`, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          username: username,
        },
        body: JSON.stringify({
          companyId: companyid,
          year: year,
          legalEntity: legal,
          businessUnit: business,
          country: country,
          site: site,
          supplier: supplier,
        }),
      })

      if (response.status === 200) {
        const responseJson = await response.json()

        if (responseJson.success === false || responseJson.status === 400) {
          setActiveEntities("")
          setActiveYears("")
          setBusinessUnit("")
          setCountries("")
          setActiveSite("")
          setAllSupplier("")
        } else {
          let legalOptions
          let businessOptions
          let countryOptions
          let siteOptions
          let supplierOptions
          let yearOptions
          // Check if any filters are selected
          const isAnyFilterSelected =
            year.length > 0 ||
            legal.length > 0 ||
            business.length > 0 ||
            country.length > 0 ||
            site.length > 0 ||
            supplier.length > 0

          // Generate dropdown options based on whether any filters are selected
          if (
            year.length > 0 &&
            legal.length === 0 &&
            business.length === 0 &&
            country.length === 0 &&
            site.length === 0 &&
            supplier.length === 0
          ) {
            yearOptions = Object.entries(responseJson.year).map(([key]) => ({
              label: key,
              value: key,
            }))
          } else {
            yearOptions = Object.entries(responseJson.year)
              .map(([key]) => ({
                label: key,
                value: key,
              }))
          }

          if (
            year.length === 0 &&
            legal.length > 0 &&
            business.length === 0 &&
            country.length === 0 &&
            site.length === 0 &&
            supplier.length === 0
          ) {
            legalOptions = Object.entries(responseJson.legalEntity).map(([key]) => ({
              label: key,
              value: key,
            }))
          } else {
            legalOptions = Object.entries(responseJson.legalEntity)
              .map(([key]) => ({
                label: key,
                value: key,
              }))
          }

          if (
            year.length === 0 &&
            legal.length === 0 &&
            business.length > 0 &&
            country.length === 0 &&
            site.length === 0 &&
            supplier.length === 0
          ) {
            businessOptions = Object.entries(responseJson.businessUnit).map(([key]) => ({
              label: key,
              value: key,
            }))
          } else {
            businessOptions = Object.entries(responseJson.businessUnit)
              .map(([key]) => ({
                label: key,
                value: key,
              }))
          }

          if (
            year.length === 0 &&
            legal.length === 0 &&
            business.length === 0 &&
            country.length > 0 &&
            site.length === 0 &&
            supplier.length === 0
          ) {
            countryOptions = Object.entries(responseJson.country).map(([key]) => ({
              label: key,
              value: key,
            }))
          } else {
            countryOptions = Object.entries(responseJson.country)
              .map(([key]) => ({
                label: key,
                value: key,
              }))
          }

          if (
            year.length === 0 &&
            legal.length === 0 &&
            business.length === 0 &&
            country.length === 0 &&
            site.length > 0 &&
            supplier.length === 0
          ) {
            siteOptions = Object.entries(responseJson.site).map(([key]) => ({
              label: key,
              value: key,
            }))
          } else {
            siteOptions = Object.entries(responseJson.site)
              .map(([key]) => ({
                label: key,
                value: key,
              }))
          }

          if (
            year.length === 0 &&
            legal.length === 0 &&
            business.length === 0 &&
            country.length === 0 &&
            site.length === 0 &&
            supplier.length > 0
          ) {
            supplierOptions = Object.entries(responseJson.supplier).map(([key]) => ({
              label: key,
              value: key,
            }))
          } else {
            supplierOptions = Object.entries(responseJson.supplier)
              .map(([key]) => ({
                label: key,
                value: key,
              }))
          }

          // Set the dropdown options
          setActiveYears(yearOptions)
          setActiveEntities(legalOptions)
          setBusinessUnit(businessOptions)
          setCountries(countryOptions)
          setActiveSite(siteOptions)
          setAllSupplier(supplierOptions)

          // Update local storage with selected values
          localStorage.setItem("travelLogisticLegal", JSON.stringify(legal))
          setLegal(legal)

          localStorage.setItem("travelLogisticBusiness", JSON.stringify(business))
          setBusiness(business)

          localStorage.setItem("travelLogisticCountry", JSON.stringify(country))
          setCountry(country)

          localStorage.setItem("travelLogisticSite", JSON.stringify(site))
          setSite(site)

          localStorage.setItem("travelLogisticSupplier", JSON.stringify(supplier))
          setSupplier(supplier)

          localStorage.setItem("travelLogisticYear", JSON.stringify(year))
          setYear(year)
        }
      } else {
        setActiveEntities("")
        setActiveYears("")
        setBusinessUnit("")
        setCountries("")
        setActiveSite("")
        setAllSupplier("")
      }
    } catch (error) {
      console.error(error)
    }
  }

  async function fetchBusinessTravelDashboard() {
    try {
      setLoading(true)

      var myHeaders = new Headers()
      myHeaders.append("username", username)
      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      }
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}business-travel-dashboard-travel-logistics`, {
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          username: username,
        },
      })
      if (response.status === 200) {
        const responseJson = await response.json()
        if (responseJson.success === false || responseJson.status === 400) {
          setLoading(false)
        } else {
          setBusinessTravelDashboard(responseJson)
          setLoading(false)
        }
      } else {
        setLoading(false)
      }
    } catch (error) {
      console.error(error)
      setLoading(false)
    }
  }

  useEffect(() => {
    appInsights.trackPageView()
    fetchBusinessTravelDashboard()
  }, [])

  // Consuption by supplier start
  const consumptionBySupplier = scope && scope.consumptionBySupplier

  const seriesData = consumptionBySupplier
    ? Object.entries(consumptionBySupplier).map(([supplierName, electricityConsumption]) => ({
        name: supplierName,
        y: Number.parseFloat(electricityConsumption),
      }))
    : []
  const seriesData_location = consumptionBySupplier
    ? Object.entries(consumptionBySupplier).map(([supplierName, electricityConsumption]) => ({
        name: supplierName,
        y: Number.parseFloat(electricityConsumption),
      }))
    : []

  const renderHeader = () => {
    const loginType = localStorage.getItem("loginType")
    if (loginType === "AAD") {
      return <AADHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />
    }
    return <LoginHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />
  }

  const [selectedOption, setSelectedOption] = useState("Upstream")

  const handleSelect = (option) => {
    setSelectedOption(option)
  }

  //chart 1
  const travelModeColors = {
    Flight: "#6D9157",
    Rail: "#EBEBEB",
    Bus: "#B4A34A",
    Taxi: "#6F9896",
    Hotel: "#FAB430",
  }

  const chartData = Object.entries(businessTravelDashboard?.emissionsByTravelMode || {}).map(([name, y]) => ({
    name,
    y,
    color: travelModeColors[name] || "#ccc",
  }))

  const yearObj = businessTravelDashboard?.businessTravelEmissionsYearwise || {}
  const years = Object.keys(yearObj)
    .map(Number)
    .sort((a, b) => b - a) // Descending
  const currentYear = years[0] || new Date().getFullYear()
  const previousYear = years[1] || currentYear - 1

  const emissionsDataBT = {
    title: "Business Travel Emissions (tCO2e)",
    currentYear: yearObj[currentYear] || 0,
    previousYear: yearObj[previousYear] || 0,
    change: businessTravelDashboard?.change || 0,
    chartData: chartData,
    currentYearLabel: currentYear,
    previousYearLabel: previousYear,
  }

  // Check if Business Travel has valid data
  const hasBusinessTravelData =
    hasValidData(businessTravelDashboard?.emissionsByTravelMode) &&
    emissionsDataBT.chartData.length > 0 &&
    emissionsDataBT.chartData.some((item) => item.y > 0)

  const emissionsChartConfigBT = {
    chart: {
      type: "pie",
      height: 280,
      style: {
        fontFamily: "poppins",
      },
      spacingBottom: 10, // Reduced bottom spacing
      spacingTop: 10,
      spacingLeft: 10,
      spacingRight: 10,
    },
    title: {
      text: null, // Remove the title from the chart
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          connectorColor: "#707070",
          format: "{point.percentage:.1f}%",
          style: {
            color: "#333",
            fontWeight: "400",
          },
        },
        showInLegend: true,
        size: "85%", // Reduced size to create more consistent spacing
      },
    },
    legend: {
      enabled: true,
      layout: "horizontal",
      align: "center",
      verticalAlign: "bottom",
      borderWidth: 0,
      itemStyle: {
        color: "#494949",
        fontWeight: "600",
        fontSize: "12px", // Standardized font size
        textAlign: "center",
      },
      itemDistance: 20, // Standardized spacing between items
      y: 5, // Reduced vertical position
    },
    series: [
      {
        name: "Travel Mode",
        data: emissionsDataBT.chartData.map((item) => ({
          id: item.id,
          name: item.name,
          y: item.y,
          color: item.color,
        })),
      },
    ],
    colors: ["#6D9157", "#EBEBEB", "#B4A34A", "#6F9896", "#FAB430"],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 768,
          },
          chartOptions: {
            chart: {
              width: "100%",
              height: "auto",
              spacingBottom: 5,
            },
            legend: {
              y: 0,
            },
          },
        },
        {
          condition: {
            maxWidth: 425,
          },
          chartOptions: {
            chart: {
              width: "100%",
              height: "auto",
              spacingBottom: 5,
            },
            legend: {
              enabled: true,
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
              borderWidth: 0,
              itemStyle: {
                color: "#494949",
                fontWeight: "400",
                fontSize: "10px",
              },
              y: 0,
            },
            plotOptions: {
              pie: {
                dataLabels: {
                  style: {
                    fontSize: "10px",
                  },
                },
                showInLegend: true,
              },
            },
          },
        },
      ],
    },
  }

  const emissionsDataEC = {
    title: "Employee Commute Emissions (tCO2e)",
    currentYear: 6163,
    previousYear: 6348,
    change: -3,
    chartData: [
      { name: "Car", y: 39, color: "#6D9157" },
      { name: "Motorcycle", y: 2, color: "#EBEBEB" },
      { name: "Cab", y: 10, color: "#6F9896" },
      { name: "Bus", y: 6, color: "#B4C9C8" },
      { name: "Metro", y: 30, color: "#D7AB3A" },
      { name: "Others", y: 13, color: "#FAB430" },
    ],
  }

  // Check if Employee Commute has valid data
  const hasEmployeeCommuteData =
    emissionsDataEC.chartData.length > 0 && emissionsDataEC.chartData.some((item) => item.y > 0)

  const emissionsChartConfigEC = {
    chart: {
      type: "pie",
      height: 280, // Matched height with BT chart
      style: {
        fontFamily: "poppins",
      },
      spacingBottom: 10, // Reduced bottom spacing
      spacingTop: 10,
      spacingLeft: 10,
      spacingRight: 10,
    },
    title: {
      text: null, // Remove the title from the chart
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          connectorColor: "#707070",
          format: "{point.percentage:.1f}%",
          style: {
            color: "#333",
            fontWeight: "400",
          },
        },
        showInLegend: true,
        size: "85%", // Matched size with BT chart
      },
    },
    legend: {
      enabled: true,
      layout: "horizontal",
      verticalAlign: "bottom",
      borderWidth: 0,
      itemStyle: {
        color: "#494949",
        fontWeight: "400",
        fontSize: "12px", // Standardized font size
      },
      itemDistance: 20, // Standardized spacing
      y: 5, // Reduced vertical position
    },
    series: [
      {
        name: "Commute Mode",
        data: emissionsDataEC.chartData.map((item) => ({
          id: item.id,
          name: item.name,
          y: item.y,
          color: item.color,
        })),
      },
    ],
    colors: ["#6D9157", "#EBEBEB", "#6F9896", "#B4C9C8", "#D7AB3A", "#FAB430"],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 768,
          },
          chartOptions: {
            chart: {
              width: "100%",
              height: "auto",
              spacingBottom: 5,
            },
            legend: {
              itemStyle: {
                fontSize: "10px",
              },
              y: 0,
            },
          },
        },
        {
          condition: {
            maxWidth: 425,
          },
          chartOptions: {
            chart: {
              width: "100%",
              height: "auto",
              spacingBottom: 5,
            },
            legend: {
              enabled: true,
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
              borderWidth: 0,
              itemStyle: {
                color: "#494949",
                fontWeight: "400",
                fontSize: "10px",
              },
              itemMarginTop: 6,
              itemMarginBottom: 6,
              symbolRadius: 10,
              y: 0,
            },
            plotOptions: {
              pie: {
                dataLabels: {
                  style: {
                    fontSize: "10px",
                  },
                },
              },
            },
          },
        },
      ],
    },
  }

  // chart 3
  const emissionsDataTD = {
    title: "Transportation and Distribution Emissions (tCO2e)",
    upstream: { current: 3028, previous: 2937, change: 3 },
    downstream: { current: 546, previous: 557, change: -2 },
    chartDataUpstream: [
      { name: "Air Transport", y: 40, color: "#6D9157" },
      { name: "Marine Transport", y: 14, color: "#FAB430" },
      { name: "Rail Transport", y: 7, color: "#E9E9E9" },
      { name: "Road Transport", y: 27, color: "#6F9896" },
      { name: "Storage facilities", y: 9, color: "#D7AB3A" },
      { name: "Fugitive emissions", y: 3, color: "#B4C9C8" },
    ],
    chartDataDownstream: [
      { name: "Air Transport", y: 30, color: "#6D9157" },
      { name: "Marine Transport", y: 18, color: "#FAB430" },
      { name: "Rail Transport", y: 5, color: "#E9E9E9" },
      { name: "Road Transport", y: 25, color: "#6F9896" },
      { name: "Storage facilities", y: 12, color: "#D7AB3A" },
      { name: "Fugitive emissions", y: 10, color: "#B4C9C8" },
    ],
  }

  // Check if Transportation and Distribution has valid data
  const hasTransportationData =
    (isUpstream ? emissionsDataTD.chartDataUpstream : emissionsDataTD.chartDataDownstream).length > 0 &&
    (isUpstream ? emissionsDataTD.chartDataUpstream : emissionsDataTD.chartDataDownstream).some((item) => item.y > 0)

const emissionsChartConfigTD = {
  chart: {
    type: "pie",
    height: 250, // Reduced chart height
    style: {
      fontFamily: "poppins",
    },
    spacingBottom: 40, // Adds space below pie chart
    spacingTop: 10,
    spacingLeft: 10,
    spacingRight: 10,
  },
  title: {
    text: null,
  },
  tooltip: {
    pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: "pointer",
      dataLabels: {
        enabled: true,
        connectorColor: "#707070",
        format: "{point.percentage:.1f}%",
        style: {
          color: "#333",
          fontWeight: "400",
        },
      },
      showInLegend: true,
      size: "80%", // Smaller pie chart size
    },
  },
  legend: {
    enabled: true,
    layout: "horizontal",
    align: "center",
    verticalAlign: "bottom",
    y: 20, // Pushes legend downward for spacing
    borderWidth: 0,
    itemStyle: {
      color: "#494949",
      fontWeight: "400",
      fontSize: "12px",
      textAlign: "center", // Center-align legend text
    },
    itemDistance: 5,
    symbolPadding: 5,
  },
  series: [
    {
      name: "Transport Mode",
      data: isUpstream
        ? emissionsDataTD.chartDataUpstream
        : emissionsDataTD.chartDataDownstream,
    },
  ],
  colors: ["#6D9157", "#FAB430", "#E9E9E9", "#6F9896", "#D7AB3A", "#B4C9C8"],
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 768,
        },
        chartOptions: {
          chart: {
            height: 220,
            spacingBottom: 30,
          },
          legend: {
            itemStyle: {
              fontSize: "10px",
              textAlign: "center",
            },
            y: 10,
            itemDistance: 8,
          },
          plotOptions: {
            pie: {
              size: "70%",
              dataLabels: {
                style: {
                  fontSize: "10px",
                },
              },
            },
          },
        },
      },
      {
        condition: {
          maxWidth: 425,
        },
        chartOptions: {
          chart: {
            height: 200,
            spacingBottom: 20,
          },
          legend: {
            layout: "horizontal",
            align: "center",
            verticalAlign: "bottom",
            y: 10,
            itemStyle: {
              fontSize: "10px",
              textAlign: "center",
            },
            symbolRadius: 10,
            itemDistance: 5,
          },
          plotOptions: {
            pie: {
              size: "65%",
              dataLabels: {
                style: {
                  fontSize: "9px",
                },
              },
            },
          },
        },
      },
    ],
  },
};




  return (
    <div id="wrapper">
      <div>
        {loading && (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </div>
      {renderHeader()}
      <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div id="page-content-wrapper" className={isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"}>
        {/* Rest of your existing JSX content */}
        <div
          className="container"
          style={{ marginLeft: "auto", marginRight: "auto", paddingLeft: "30px", paddingRight: "20px" }}
        >
          <div className="row">
            <div className="col-12 col-md-6">
              <div className="steps__containt-hader">
                <h3 className="title">Travel and Logistics</h3>
                <div role="presentation">
                  <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                    <Link underline="hover" color="inherit" href="/esg-dashboard" className="link">
                      Dashboard
                    </Link>
                    <Typography color="text.primary">Travel and Logistics</Typography>
                  </Breadcrumbs>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 d-flex align-items-center justify-content-md-end flex-wrap gap-2">
              <div className="row justify-content-md-end my-2">
                <div className="col-auto">
                  <Button className="refresh-cta" variant="text" startIcon={<MdRefresh />}>
                    Refresh
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <div className="travel-logistic-dashboard" style={dashboardStyles.cardContainer}>
            {/* Charts Section */}
            <div className="row" style={{ gap: "0px", margin: "0" }}>
              {/* Business Travel Chart */}
              <div className="col-12 col-lg-6" style={{ paddingLeft: "0", paddingRight: "10px", marginBottom: "0px" }}>
                <div className="charts BTCEC-main" style={{ height: "100%", marginBottom: "0" }}>
                  <div className="BTCEC-header d-flex align-items-start m-2" style={{ width: "274px" }}>
                    {/* SVG Icon */}
                    <img
                      src="./assets/img/icon/BT.svg"
                      alt="Business Travel Icon"
                      width="45"
                      height="40"
                      className="BTCEC-img"
                    />

                    {/* Title and Subtitle */}
                    <div className="d-flex flex-column align-items-start ml-1">
                      <h6 className="fw-semibold" style={{ fontFamily: "Poppins", marginBottom: "0" }}>
                        Business Travel
                      </h6>
                      <p style={{ fontSize: "12px", color: "#555", marginTop: "0" }}>Emissions (tCO2)</p>
                    </div>
                  </div>

                  {hasBusinessTravelData ? (
                    <>
                      <div className="BTCEC-emissions row mt-3 ml-1" style={{ fontFamily: "Poppins" }}>
                        <div className="BTCEC-emissions-data">
                          <p style={{ fontSize: "12px", color: "#A3A3A3", textAlign: "left" }}>
                            {emissionsDataBT.currentYearLabel}
                          </p>
                          <p
                            className="fw-bold"
                            style={{
                              fontSize: "18px",
                              color: "#494949",
                              marginTop: "-15px",
                              textAlign: "left",
                            }}
                          >
                            {emissionsDataBT.currentYear.toLocaleString()}
                          </p>
                          <p style={{ fontSize: "12px", color: "#A3A3A3", textAlign: "left" }}>
                            {emissionsDataBT.previousYearLabel}
                          </p>
                          <p
                            className="fw-bold"
                            style={{
                              fontSize: "18px",
                              color: "#494949",
                              marginTop: "-15px",
                              textAlign: "left",
                            }}
                          >
                            {emissionsDataBT.previousYear.toLocaleString()}
                          </p>

                          <div className="stats" style={{ fontSize: "12px", color: "#A3A3A3", textAlign: "left" }}>
                            Change
                          </div>
                          <div className="BTCEC-emissions-change" style={{ fontSize: "18px", textAlign: "left" }}>
                            <div>
                              <img
                                src={
                                  emissionsDataBT.change > 0
                                    ? "./assets/img/icon/RedUp.svg"
                                    : "./assets/img/icon/GreenDown.svg"
                                }
                                alt="change icon"
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  marginRight: "5px",
                                  position: "relative",
                                  top: "0px",
                                }}
                                className="BTCEC-img"
                              />
                            </div>

                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "18px",
                                textAlign: "left",
                              }}
                              className={emissionsDataBT.change > 0 ? "text-danger" : "text-success"}
                            >
                              {Math.abs(emissionsDataBT.change)}%
                            </div>
                          </div>
                        </div>

                        <div className="BTCEC-piechart">
                          <div
                            className="chart-title"
                            style={{
                              textAlign: "center",
                              marginBottom: "10px",
                              fontSize: "12px",
                              fontWeight: "400",
                              color: "#707070",
                            }}
                          >
                            Emissions (tCO2e) by Travel Mode
                          </div>
                          <HighchartsReact highcharts={Highcharts} options={emissionsChartConfigBT} />
                        </div>
                      </div>
                    </>
                  ) : (
                    <div style={{ marginTop: "20px" }}>
                      <NoDataComponent title="Business Travel Emissions" onConfigureClick={handleConfigureClick} />
                    </div>
                  )}

                  {/* Eye Icon Button */}
                  <button
                    onClick={hasBusinessTravelData ? handleEyeIconClickBusiness : undefined}
                    disabled={!hasBusinessTravelData}
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      backgroundColor: "transparent",
                      border: "none",
                      cursor: hasBusinessTravelData ? "pointer" : "not-allowed",
                      opacity: hasBusinessTravelData ? 1 : 0.5,
                    }}
                    aria-label="Toggle visibility"
                  >
                    <img
                      src={hasBusinessTravelData ? "./assets/img/icon/eye.svg" : "./assets/img/icon/eye.svg"}
                      alt={hasBusinessTravelData ? "View detailed emissions" : "No data available"}
                      style={{
                        height: "13px",
                        width: "18px",
                        filter: hasBusinessTravelData ? "none" : "grayscale(100%)",
                      }}
                      className="BTCEC-img"
                    />
                  </button>
                </div>
              </div>

              {/* Employee Commute Chart */}
              <div className="col-12 col-lg-6" style={{ paddingLeft: "10px", paddingRight: "0", marginBottom: "0px" }}>
                <div className="charts BTCEC-main" style={{ height: "100%", marginBottom: "0" }}>
                  <div className="BTCEC-header d-flex align-items-start m-2" style={{ width: "274px" }}>
                    {/* SVG Icon */}
                    <img
                      src="./assets/img/icon/EC.svg"
                      alt="Employee Commute Icon"
                      width="45"
                      height="40"
                      className="BTCEC-img"
                    />

                    {/* Title and Subtitle */}
                    <div className="d-flex flex-column align-items-start ml-1">
                      <h6 className="fw-semibold" style={{ fontFamily: "Poppins", marginBottom: "0" }}>
                        Employee Commute
                      </h6>
                      <p style={{ fontSize: "12px", color: "#555", marginTop: "0" }}>Emissions (tCO2)</p>
                    </div>
                  </div>

                  {hasEmployeeCommuteData ? (
                    <>
                      <div className="BTCEC-emissions row mt-3 ml-1" style={{ fontFamily: "Poppins" }}>
                        <div className="BTCEC-emissions-data">
                          <p style={{ fontSize: "12px", color: "#A3A3A3", textAlign: "left" }}>
                            {Number(new Date().getFullYear())}
                          </p>
                          <p
                            className="fw-bold"
                            style={{
                              fontSize: "18px",
                              color: "#494949",
                              marginTop: "-15px",
                              textAlign: "left",
                            }}
                          >
                            {emissionsDataEC.currentYear.toLocaleString()}
                          </p>
                          <p style={{ fontSize: "12px", color: "#A3A3A3", textAlign: "left" }}>
                            {Number(new Date().getFullYear()) - 1}
                          </p>
                          <p
                            className="fw-bold"
                            style={{
                              fontSize: "18px",
                              color: "#494949",
                              marginTop: "-15px",
                              textAlign: "left",
                            }}
                          >
                            {emissionsDataEC.previousYear.toLocaleString()}
                          </p>

                          <div className="stats" style={{ fontSize: "12px", color: "#A3A3A3", textAlign: "left" }}>
                            Change
                          </div>
                          <div className="BTCEC-emissions-change" style={{ fontSize: "18px", textAlign: "left" }}>
                            <div>
                              <img
                                src={
                                  emissionsDataEC.change > 0
                                    ? "./assets/img/icon/RedUp.svg"
                                    : "./assets/img/icon/GreenDown.svg"
                                }
                                alt="change icon"
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  marginRight: "5px",
                                  position: "relative",
                                  top: "0px",
                                }}
                                className="BTCEC-img"
                              />
                            </div>

                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "18px",
                                textAlign: "left",
                              }}
                              className={emissionsDataEC.change > 0 ? "text-danger" : "text-success"}
                            >
                              {Math.abs(emissionsDataEC.change)}%
                            </div>
                          </div>
                        </div>

                        <div className="BTCEC-piechart">
                          <div
                            className="chart-title"
                            style={{
                              textAlign: "center",
                              marginBottom: "10px",
                              fontSize: "12px",
                              fontWeight: "400",
                              color: "#707070",
                            }}
                          >
                            Emissions (tCO2e) by commute mode
                          </div>
                          <HighchartsReact highcharts={Highcharts} options={emissionsChartConfigEC} />
                        </div>
                      </div>
                    </>
                  ) : (
                    <div style={{ marginTop: "20px" }}>
                      <NoDataComponent title="Employee Commute Emissions" onConfigureClick={handleConfigureClick} />
                    </div>
                  )}

                  {/* Eye Icon Button */}
                  <button
                    onClick={hasEmployeeCommuteData ? handleEyeIconClickEmployee : undefined}
                    disabled={!hasEmployeeCommuteData}
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      backgroundColor: "transparent",
                      border: "none",
                      cursor: hasEmployeeCommuteData ? "pointer" : "not-allowed",
                      opacity: hasEmployeeCommuteData ? 1 : 0.5,
                    }}
                    aria-label="Toggle visibility"
                  >
                    <img
                      src={hasEmployeeCommuteData ? "./assets/img/icon/eye.svg" : "./assets/img/icon/eye.svg"}
                      alt={hasEmployeeCommuteData ? "View detailed emissions" : "No data available"}
                      style={{
                        height: "13px",
                        width: "18px",
                        filter: hasEmployeeCommuteData ? "none" : "grayscale(100%)",
                      }}
                      className="BTCEC-img"
                    />
                  </button>
                </div>
              </div>

              {/* Transportation and Distribution Chart */}
              <div className="col-12" style={{ paddingLeft: "0", paddingRight: "0", marginTop: "20px" }}>
                <div className="charts BTCEC-main" style={{ height: "100%", marginBottom: "0" }}>
                  {/* Header Section */}
                  <div className="TDC-header-div d-flex justify-content-between align-items-center mb-3">
                    <div className="BTCEC-header d-flex align-items-center ml-2">
                      <img
                        src="./assets/img/icon/TD.svg"
                        alt="Transport Icon"
                        width="45"
                        height="40"
                        className="BTCEC-img"
                      />
                      <div className="ml-2">
                        <h6 className="mb-0 fw-semibold">Transportation and Distribution</h6>
                        <p className="mb-0 " style={{ fontSize: "12px", color: "#555", textAlign: "left" }}>
                          Emissions (tCO2e)
                        </p>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <div
                        style={{
                          position: "absolute",
                          top: "12px",
                          right: "80px",
                          backgroundColor: "transparent",
                          border: "none",
                          cursor: "pointer",
                        }}
                      >
                        <div className="TDC-switch flex items-center">
                          <span
                            className="mr-3"
                            style={{
                              color: "#707070",
                              fontSize: "12px",
                              fontFamily: "Poppins, sans-serif",
                            }}
                          >
                            UPSTREAM
                          </span>
                          <Switch
                            checked={!isUpstream}
                            onChange={handleToggle}
                            style={{
                              backgroundColor: isUpstream ? "#407775" : "#407775",
                            }}
                            sx={{
                              "--Switch-trackHeight": "25px",
                              "--Switch-thumbSize": "19px",
                              "--Switch-trackWidth": "409px",
                              "& .ant-switch-handle": {
                                backgroundColor: "#fff",
                              },
                              "& .ant-switch": {
                                backgroundColor: "#407775",
                              },
                              "& .ant-switch-checked": {
                                backgroundColor: "#407775",
                              },
                            }}
                          />
                          <span
                            className="ml-3"
                            style={{
                              color: "#707070",
                              fontSize: "12px",
                              fontFamily: "Poppins, sans-serif",
                            }}
                          >
                            DOWNSTREAM
                          </span>
                        </div>
                      </div>
                      <button
                        onClick={hasTransportationData ? handleEyeIconClickTransportation : undefined}
                        disabled={!hasTransportationData}
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                          backgroundColor: "transparent",
                          border: "none",
                          cursor: hasTransportationData ? "pointer" : "not-allowed",
                          opacity: hasTransportationData ? 1 : 0.5,
                        }}
                        aria-label="Toggle visibility"
                      >
                        <img
                          src={hasTransportationData ? "./assets/img/icon/eye.svg" : "./assets/img/icon/eye.svg"}
                          alt={hasTransportationData ? "View detailed emissions" : "No data available"}
                          style={{
                            height: "13px",
                            width: "18px",
                            filter: hasTransportationData ? "none" : "grayscale(100%)",
                          }}
                        />
                      </button>
                    </div>
                  </div>

                  {hasTransportationData ? (
                    <>
                      {/* Emissions Data */}
                      <div className="BTCEC-emissions">
                        <div
                          className="BTCEC-emissions-data ml-3 mt-3"
                          style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2rem", maxWidth: "40%" }}
                        >
                          {/* Upstream Data */}
                          <div className="">
                            <h1
                              style={{
                                color: "#707070",
                                fontSize: "16px",
                                fontFamily: "Poppins",
                                textAlign: "left",
                              }}
                            >
                              UPSTREAM
                            </h1>
                            <div>
                              <p style={{ fontSize: "14px", color: "#A3A3A3", textAlign: "left" }}>2023</p>
                              <p
                                className="fw-bold"
                                style={{
                                  fontSize: "18px",
                                  color: "#494949",
                                  marginTop: "-15px",
                                  textAlign: "left",
                                }}
                              >
                                {emissionsDataTD.upstream.current.toLocaleString()}
                              </p>
                              <p style={{ fontSize: "12px", color: "#A3A3A3", textAlign: "left" }}>2022</p>
                              <p
                                className="fw-bold"
                                style={{
                                  fontSize: "18px",
                                  color: "#494949",
                                  marginTop: "-15px",
                                  textAlign: "left",
                                }}
                              >
                                {emissionsDataTD.upstream.previous.toLocaleString()}
                              </p>

                              <div className="stats" style={{ fontSize: "12px", color: "#A3A3A3", textAlign: "left" }}>
                                Change
                              </div>
                              <div className="BTCEC-emissions-change" style={{ fontSize: "18px", textAlign: "left" }}>
                                <div>
                                  <img
                                    src={
                                      emissionsDataTD.upstream.change > 0
                                        ? "./assets/img/icon/RedUp.svg"
                                        : "./assets/img/icon/GreenDown.svg"
                                    }
                                    alt="change icon"
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      marginRight: "5px",
                                      position: "relative",
                                      top: "-2px",
                                    }}
                                    className="BTCEC-img"
                                  />
                                </div>

                                <div
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "18px",
                                    textAlign: "left",
                                  }}
                                  className={emissionsDataTD.upstream.change > 0 ? "text-danger" : "text-success"}
                                >
                                  {Math.abs(emissionsDataTD.upstream.change)}%
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Downstream Data */}
                          <div>
                            <h1
                              style={{
                                color: "#707070",
                                fontSize: "16px",
                                fontFamily: "Poppins",
                              }}
                            >
                              DOWNSTREAM
                            </h1>
                            <div>
                              <p style={{ fontSize: "12px", color: "#A3A3A3", textAlign: "left" }}>2023</p>
                              <p
                                className="fw-bold"
                                style={{
                                  fontSize: "18px",
                                  color: "#494949",
                                  marginTop: "-15px",
                                  textAlign: "left",
                                }}
                              >
                                {emissionsDataTD.downstream.current.toLocaleString()}
                              </p>
                              <p style={{ fontSize: "12px", color: "#A3A3A3", textAlign: "left" }}>2022</p>
                              <p
                                className="fw-bold"
                                style={{
                                  fontSize: "18px",
                                  color: "#494949",
                                  marginTop: "-15px",
                                  textAlign: "left",
                                }}
                              >
                                {emissionsDataTD.downstream.previous.toLocaleString()}
                              </p>
                              <div className="stats" style={{ fontSize: "12px", color: "#A3A3A3", textAlign: "left" }}>
                                Change
                              </div>
                              <div className="BTCEC-emissions-change" style={{ fontSize: "18px", textAlign: "left" }}>
                                <div>
                                  <img
                                    src={
                                      emissionsDataTD.downstream.change > 0
                                        ? "./assets/img/icon/RedUp.svg"
                                        : "./assets/img/icon/GreenDown.svg"
                                    }
                                    alt="change icon"
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      marginRight: "5px",
                                      position: "relative",
                                      top: "0px",
                                    }}
                                    className="BTCEC-img"
                                  />
                                </div>

                                <div
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "18px",
                                    textAlign: "left",
                                  }}
                                  className={emissionsDataTD.downstream.change > 0 ? "text-danger" : "text-success"}
                                >
                                  {Math.abs(emissionsDataTD.downstream.change)}%
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Pie Chart */}
                        <div className="BTCEC-piechart">
                          <div
                            className="chart-title"
                            style={{
                              textAlign: "center",
                              marginBottom: "10px",
                              fontSize: "12px",
                              fontWeight: "400",
                              color: "#707070",
                            }}
                          >
                            Emissions (tCO2e) by Transport Mode
                          </div>
                          <HighchartsReact highcharts={Highcharts} options={emissionsChartConfigTD} />
                        </div>
                      </div>
                    </>
                  ) : (
                    <div style={{ marginTop: "20px" }}>
                      <NoDataComponent
                        title="Transportation and Distribution Emissions"
                        onConfigureClick={handleConfigureClick}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
